import React from 'react';
import "./Table.css";
import dealer from '../img/dealer.png'
// import chips from '../img/chips.png';


export default function Table(props) {

  function cardNumberToName(card){
    if (Math.floor(card / 4) === 0) {
      return 'A';
    }
    else if( Math.floor(card / 4) < 9) {
      // 2 through 9
      return (Math.floor(card / 4) + 1).toString();
    }
    else if (card / 4 >= 12){
      return 'K';
    }else if (card / 4 >= 11){
      return 'Q';
    }else if (card / 4 >= 10){
      return 'J';
    }
    else if (card / 4 >=9){
      return '10';
    }
  }

  function heighestChipStack(){
    return Math.max(redHeight, greenHeight, blueHeight, blackHeight, whiteHeight);
  }

  function getMoneyStage(){
    if (props.money >= 10000){
      return 15;
    }else if (props.money >= 9000){
      return 14;
    }else if (props.money >= 8000){
      return 13;
    }else if (props.money >= 6800){
      return 12;
    }else if (props.money >= 5500){
      return 11;
    }else if (props.money >= 4500){
      return 10;
    }else if (props.money >= 3800){
      return 9;
    }else if (props.money >= 3100){
      return 8;
    }else if (props.money >= 2400){
      return 7;
    }else if (props.money >= 1200){
      return 6;
    }else if (props.money >= 600){
      return 5;
    }else if (props.money >= 300){
      return 4;
    }else if (props.money >= 100){
      return 3;
    }else if (props.money >= 50){
      return 2;
    }else if (props.money >= 0){
      return 1;
    }else if (props.money === 0){
      return 0;
    }
  }

  let moneyStage = getMoneyStage();
  let redHeight = 0;
  let greenHeight = 0;
  let blueHeight = 0;
  let blackHeight = 0;
  let whiteHeight = 0;
  if (moneyStage > 0) redHeight = 1;
  if (moneyStage > 1) greenHeight = 1;
  if (moneyStage > 2) blueHeight = 1;
  if (moneyStage > 3) blackHeight = 1;
  if (moneyStage > 4) whiteHeight = 1;
  if (moneyStage > 5) blackHeight = 2;
  if (moneyStage > 6) whiteHeight = 2;
  if (moneyStage > 7) redHeight = 2;
  if (moneyStage > 8) greenHeight = 2;
  if (moneyStage > 9) blueHeight = 2;
  if (moneyStage > 10) blackHeight = 3;
  if (moneyStage > 11) whiteHeight = 3;
  if (moneyStage > 12) redHeight = 3;
  if (moneyStage > 13) greenHeight = 3;
  if (moneyStage > 14) blueHeight = 3;

  return (
    <>
    <img className="dealer" src={dealer} alt=""/>
    <div className="table">
      <div style={{ width: '50%', margin: 'auto', marginTop: '3vh', whiteSpace: 'nowrap'}}>
        <div className="dealer_chips">
          <img className="chips" style={{zIndex: '10', position: 'relative'}} src={require('../img/3StackRed.png').default} alt=""/>
          <img className="chips" style={{zIndex: '1', position: 'relative', marginLeft: '-12.5%', marginBottom: '2.75vh'}} src={require('../img/3StackBlack.png').default} alt=""/>
          <img className="chips" style={{zIndex: '10', position: 'relative', marginLeft: '-12.5%'}} src={require('../img/3StackGreen.png').default} alt=""/>
          <img className="chips" style={{zIndex: '1', position: 'relative', marginLeft: '-12.5%', marginBottom: '2.5vh'}} src={require('../img/3StackWhite.png').default} alt=""/>
          <img className="chips" style={{zIndex: '10', position: 'relative', marginLeft: '-12.5%'}} src={require('../img/3StackBlue.png').default} alt=""/>
        </div>
        <div className="dealer_cards">
          {
            (props.dealerCards.length === 0) &&
            <React.Fragment key="null">
              <img key="placeholdercard1" className="card" style={{ marginBottom: "2vh", visibility: 'hidden'}} src={require('../img/AC.png').default} alt=""/>
              <img key="placeholdercard2" className="card" style={{ marginLeft: "-37%", borderRadius: '5px', visibility: 'hidden'}} src={require('../img/cardBack.jpg').default} alt=""/>
            </React.Fragment>
          }
          {
            props.dealerCards.map((cardObj, index) => {
              let cardName = cardNumberToName(cardObj.card);
              let suitName = cardObj.suit[0];
              let fullName = cardName + suitName;
              let marginBottom = (-2 * index);
              let marginLeft = (index === 0) ? "0%": "-33%";
              if (cardObj.faceUp){
                return (
                  <img key={index} className="card" style={{ marginBottom: marginBottom + "vh", marginLeft: marginLeft}} src={require('../img/' + fullName + '.png').default} alt=""/>
                )
              }else {
                return (
                  <img key="faceDownCard" className="card" style={{ marginLeft: "0", borderRadius: '5px'}} src={require('../img/cardBack.jpg').default} alt=""/>
                );
              }
            })
          }


        </div>
        {
          (props.dealerCards.length !== 0) &&
          <label className="dealer_score" style={{color: (props.is493Jack(props.dealerCards)) ? "gold" : (props.dealerVal > 21) ? "red" : "white"}}>{props.dealerVal}</label>
        }
      </div>

      <div className="player_cards" style={{ marginTop: (heighestChipStack() === 1 || heighestChipStack() === 0) ? '9vh' : (heighestChipStack() === 2) ? '5vh' : '0vh'}}>
        {
          (props.dealerCards.length !== 0) &&
          <label className="player_score" style={{visibility: "hidden"}}>{props.playerVal}</label>
        }
        {
          (props.playerCards.length === 0) &&
          <img className="card" key="placeholdercard" style={{visibility: 'hidden'}} src={require('../img/AC.png').default} alt=""/>
        }
        {
          props.playerCards.map((cardObj, index) => {
            let cardName = cardNumberToName(cardObj.card);
            let suitName = cardObj.suit[0];
            let fullName = cardName + suitName;
            return (
              <img key={index} className="card" src={require('../img/' + fullName + '.png').default} alt=""/>
            )
          })
        }
        {
          (props.dealerCards.length !== 0) &&
          <label className="player_score" style={{color: (props.is493Jack(props.playerCards)) ? "gold" : (props.playerVal > 21) ? "red" : "white"}}>{props.playerVal}</label>
        }
      </div>

      <div className="player_chips" style={{ marginTop: (heighestChipStack() === 1 || heighestChipStack() === 0) ? '-9vh' : (heighestChipStack() === 2) ? '-5vh' : '0vh'}}>
        {
          (redHeight !== 0) &&
          <img className="chips" style={{zIndex: '10', position: 'relative'}} src={require('../img/' + redHeight + 'StackRed.png').default} alt=""/>
        }
        {
          (blackHeight !== 0) &&
          <img className="chips" style={{zIndex: '1', position: 'relative', marginLeft: '-10%', marginBottom: '2.75vh'}} src={require('../img/' + blackHeight + 'StackBlack.png').default} alt=""/>
        }
        {
          (greenHeight !== 0) &&
          <img className="chips" style={{zIndex: '10', position: 'relative', marginLeft: (!blackHeight && !whiteHeight) ? '0%' : (blackHeight && !whiteHeight) ? '-15%' : '-10%'}} src={require('../img/' + greenHeight + 'StackGreen.png').default} alt=""/>
        }
        {
          (whiteHeight !== 0) &&
          <img className="chips" style={{zIndex: '1', position: 'relative', marginLeft: '-10%', marginBottom: '2.5vh'}} src={require('../img/' + whiteHeight + 'StackWhite.png').default} alt=""/>
        }
        {
          (blueHeight !== 0) &&
          <img className="chips" style={{zIndex: '10', position: 'relative', marginLeft: (whiteHeight === 0) ? '0%' : '-10%'}} src={require('../img/' + blueHeight + 'StackBlue.png').default} alt=""/>
        }
      </div>
    </div>
    </>
  );
}
